/**
 * Tab mở từ bản trước khi deploy: `main.js` cũ (cache) đòi chunk mà bản mới đã xoá; S3/CloudFront
 * trả `index.html` cho file thiếu ⇒ `ChunkLoadError`, và vì `main.tsx` nạp `bootstrap` bằng
 * dynamic import nên lỗi bị nuốt — khung «Đang mở trang làm việc của trạm…» đứng mãi, F5 không
 * thoát (dogfood P2 SIT 01/10, vai rushed). Xử: làm mới bản HTML trong cache rồi tải lại MỘT lần;
 * vẫn hỏng thì nói ra thay vì quay mãi.
 */
const KHOA = 'scms:reload-after-stale-bundle';

export async function recoverFromStaleBundle(
  err: unknown,
  env: {
    storage: Pick<Storage, 'getItem' | 'setItem' | 'removeItem'> | null;
    refetchHtml: () => Promise<unknown>;
    reload: () => void;
    showError: (message: string) => void;
  },
): Promise<'reloaded' | 'shown'> {
  let daThu = false;
  try { daThu = env.storage?.getItem(KHOA) === '1'; } catch { /* storage bị chặn: coi như chưa thử */ }
  if (!daThu) {
    try { env.storage?.setItem(KHOA, '1'); } catch { /* bỏ qua */ }
    await env.refetchHtml().catch(() => undefined);
    env.reload();
    return 'reloaded';
  }
  try { env.storage?.removeItem(KHOA); } catch { /* bỏ qua */ }
  const chiTiet = err instanceof Error ? err.name : 'lỗi tải trang';
  env.showError(`Không mở được trang làm việc (${chiTiet}). Đóng tab này rồi mở lại portal; nếu vẫn vậy, xoá dữ liệu duyệt web của trang rồi thử lại.`);
  return 'shown';
}

/** Bản đã mở được thì xoá dấu, để lần deploy sau còn một lượt tự tải lại. */
export function markBundleHealthy(storage: Pick<Storage, 'removeItem'> | null): void {
  try { storage?.removeItem(KHOA); } catch { /* bỏ qua */ }
}
